import { useEffect, useState } from "react"
import Select from "react-dropdown-select"


const SelectFilterCounts = ({ searchParams, setSearchParams, label, optionsArray, field, withCount = true, multi = true }) => {
  const [options, setOptions] = useState([])
  const [values, setValues] = useState([])
  useEffect(() => {
    const newOptions = optionsArray.map(item => ({ label: withCount ? `${item.value}(${item.count})` : item.value, value: item.value }))
    setOptions(newOptions)
  }, [optionsArray])

  useEffect(() => {
    const newValues = searchParams.get(field) ? options.filter(i => searchParams.get(field).split(',,').includes(i.value)) : []
    setValues(newValues)
  }, [options, searchParams.get(field)])

  return <div className="min-w-40 shrink-0 mx-1"><Select
    options={options}
    key={values.join('-')}
    placeholder={label}
    multi={multi}
    values={values}
    onChange={next => {
      setSearchParams(prev => {
        if (next.length == options.length) {
          prev.set(field, "")
        } else {
          prev.set(field, next.map(i => i.value).join(',,'))
        }
        return prev
      })
    }}

  />
  </div>
}

export default SelectFilterCounts
